export default function ClarityLogomark() {
  return (
    <svg
      width="28"
      height="26"
      viewBox="0 41 240 208"
      fill="none"
      className="shrink-0"
    >
      <path
        d="M119.506 210.703L130.566 221.793C147.666 238.939 170.854 248.568 195.031 248.568C195.031 206.75 161.222 172.839 119.506 172.839C77.79 172.839 43.9805 206.739 43.9805 248.568C68.1574 248.568 91.346 238.939 108.446 221.793L119.506 210.703Z"
        fill="#FF2D00"
      />
      <path
        d="M70.464 125.517L55.3514 129.581C32.003 135.846 12.0885 151.17 0 172.159C36.1257 193.068 82.313 180.657 103.166 144.444C124.019 108.221 111.641 61.909 75.525 41C63.437 61.9991 60.1628 86.9418 66.4217 110.363L70.474 125.517H70.464Z"
        fill="#FF2D00"
      />
      <path
        d="M168.57 125.516L172.623 110.363C178.882 86.9413 175.598 61.9986 163.509 40.9995C127.383 61.9085 115.015 108.221 135.868 144.444C156.721 180.667 202.909 193.068 239.035 172.159C226.946 151.16 207.032 135.846 183.683 129.57L168.57 125.506V125.516Z"
        fill="#FF2D00"
      />
    </svg>
  );
}
